import { gql } from '@apollo/client'

export const GENERATE_CHANNEL_API_KEYS_MUTATION = gql`
  mutation GenerateChannelAPIKey($input: GenerateChannelAPIKeyInput!) {
    generateChannelAPIKey(input: $input) {
      message
    }
  }
`
